export const animeList = [
  {
    id: "1",
    title: "苍穹之翼",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20young%20pilot%20with%20glowing%20orange%20aura%20soaring%20above%20clouds%2C%20futuristic%20airship%20in%20background%2C%20vibrant%20warm%20colors%2C%20dramatic%20sky%2C%20detailed%20poster%20art&width=600&height=900&seq=anime-cover-01&orientation=portrait",
    rating: 9.2,
    type: "热血",
    region: "日本",
    year: 2024,
    status: "连载中",
    episodes: 12,
    totalEpisodes: 24,
    popularity: 9850,
    updatedAt: "2024-10-08",
    summary: "少年驾驶古老苍穹战机，在天空之城展开热血冒险。",
    synopsis: "在被浮空岛屿分割的世界里，普通少年凌风意外唤醒了沉睡百年的苍穹战机「翼」。为了寻找失踪的姐姐，他与一群性格各异的伙伴踏上穿越云海的旅程。天空之上隐藏着古老的秘密，而凌风的每一次飞行，都在改变整个世界的命运。",
    tags: ["天空冒险", "机甲", "成长"],
    episodesList: [
      { no: 1, title: "觉醒的战机", duration: "24:00" },
      { no: 2, title: "云海之上", duration: "24:00" },
      { no: 3, title: "失踪的姐姐", duration: "23:40" },
      { no: 4, title: "天空之城", duration: "24:10" },
      { no: 5, title: "暴雨航线", duration: "24:00" },
      { no: 6, title: "火焰的誓言", duration: "23:55" },
      { no: 7, title: "暗流涌动", duration: "24:00" },
      { no: 8, title: "翼之真名", duration: "24:20" },
      { no: 9, title: "王座之下", duration: "24:00" },
      { no: 10, title: "逆风者", duration: "23:50" },
      { no: 11, title: "裂空", duration: "24:00" },
      { no: 12, title: "苍穹之约", duration: "25:00" },
    ],
  },
  {
    id: "2",
    title: "星海拾光者",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20girl%20collecting%20glowing%20starlight%20in%20a%20lantern%2C%20deep%20starfield%20background%2C%20soft%20teal%20and%20gold%20tones%2C%20dreamy%20healing%20atmosphere%2C%20detailed%20poster%20art&width=600&height=900&seq=anime-cover-02&orientation=portrait",
    rating: 8.8,
    type: "科幻",
    region: "日本",
    year: 2023,
    status: "已完结",
    episodes: 13,
    totalEpisodes: 13,
    popularity: 7420,
    updatedAt: "2024-09-22",
    summary: "在星海尽头，少女收集逝去的记忆之光。",
    synopsis: "宇宙中每一颗熄灭的星星，都会留下一缕记忆之光。少女拾光者带着会说话的星灯，穿梭于濒临消散的星球之间，收集人们最后的思念。这是一段关于告别与铭记的温柔旅程。",
    tags: ["星际", "治愈", "单元剧"],
    episodesList: [
      { no: 1, title: "第一个黄昏", duration: "22:30" },
      { no: 2, title: "海水星的告别", duration: "22:10" },
      { no: 3, title: "机器人的花园", duration: "22:00" },
      { no: 4, title: "无声的歌", duration: "22:40" },
      { no: 5, title: "灯塔守夜人", duration: "22:00" },
      { no: 6, title: "时间的琥珀", duration: "22:20" },
      { no: 7, title: "遗失的坐标", duration: "22:00" },
      { no: 8, title: "双生星", duration: "22:30" },
      { no: 9, title: "最后的花火", duration: "22:10" },
      { no: 10, title: "归途", duration: "22:00" },
      { no: 11, title: "星海尽头", duration: "23:00" },
      { no: 12, title: "拾光者的名字", duration: "22:30" },
      { no: 13, title: "光不熄灭", duration: "24:00" },
    ],
  },
  {
    id: "3",
    title: "樱色恋歌",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20two%20students%20under%20blooming%20cherry%20blossom%20trees%2C%20warm%20pink%20and%20cream%20palette%2C%20romantic%20spring%20campus%20scene%2C%20soft%20lighting%2C%20detailed%20poster%20art&width=600&height=900&seq=anime-cover-03&orientation=portrait",
    rating: 8.5,
    type: "恋爱",
    region: "日本",
    year: 2024,
    status: "连载中",
    episodes: 8,
    totalEpisodes: 12,
    popularity: 6980,
    updatedAt: "2024-10-05",
    summary: "转学生与文艺社少女，在樱花树下开始的恋歌。",
    synopsis: "高二的春天，转学生周和遇见了总在樱花下画画的少女苏晴。一场关于暗恋、错过与勇气的青春物语，在四季流转中缓缓展开。每一片落下的花瓣，都写着他们想说又没说的话。",
    tags: ["校园", "青春", "治愈"],
    episodesList: [
      { no: 1, title: "转学的春天", duration: "23:00" },
      { no: 2, title: "文艺社的午后", duration: "23:10" },
      { no: 3, title: "未寄出的信", duration: "23:00" },
      { no: 4, title: "雨中的伞", duration: "22:50" },
      { no: 5, title: "夏日祭", duration: "23:20" },
      { no: 6, title: "烟花下的秘密", duration: "23:00" },
      { no: 7, title: "秋的信笺", duration: "22:55" },
      { no: 8, title: "第一场雪", duration: "23:30" },
    ],
  },
  {
    id: "4",
    title: "暗影猎手",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20hooded%20hunter%20holding%20a%20glowing%20dark%20blade%2C%20neon%20city%20alley%20background%2C%20intense%20orange%20and%20deep%20shadow%20contrast%2C%20action%20poster%20art&width=600&height=900&seq=anime-cover-04&orientation=portrait",
    rating: 9.0,
    type: "战斗",
    region: "中国",
    year: 2023,
    status: "连载中",
    episodes: 20,
    totalEpisodes: 26,
    popularity: 9120,
    updatedAt: "2024-10-09",
    summary: "都市暗影中，猎手们与异形文明的无声战争。",
    synopsis: "每当夜幕降临，城市阴影里潜伏着来自异界的「影」。猎手组织「燧火」的年轻成员夜阑，必须在保护普通人的同时，揭开自己被封印的身世真相。刀锋所至，黑暗退散。",
    tags: ["都市", "异能", "战斗"],
    episodesList: [
      { no: 1, title: "影之降临", duration: "24:00" },
      { no: 2, title: "燧火总部", duration: "24:00" },
      { no: 3, title: "第一把刀", duration: "24:05" },
      { no: 4, title: "夜巡", duration: "24:00" },
      { no: 5, title: "旧日档案", duration: "24:10" },
      { no: 6, title: "同僚", duration: "23:55" },
      { no: 7, title: "镜中之敌", duration: "24:00" },
      { no: 8, title: "封印之地", duration: "24:20" },
      { no: 9, title: "黎明前的刀", duration: "24:00" },
      { no: 10, title: "碎裂的护符", duration: "23:50" },
      { no: 11, title: "猎与猎", duration: "24:00" },
      { no: 12, title: "无月之夜", duration: "24:15" },
      { no: 13, title: "重铸", duration: "24:00" },
      { no: 14, title: "叛徒", duration: "23:58" },
      { no: 15, title: "深巷追迹", duration: "24:00" },
      { no: 16, title: "影王低语", duration: "24:05" },
      { no: 17, title: "血的记忆", duration: "24:00" },
      { no: 18, title: "破晓行动", duration: "24:30" },
      { no: 19, title: "最后一夜", duration: "24:00" },
      { no: 20, title: "燧火不灭", duration: "25:00" },
    ],
  },
  {
    id: "5",
    title: "龙脊少年",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20boy%20standing%20on%20a%20dragon%20ridge%20mountain%20peak%20wielding%20an%20ancient%20sword%2C%20epic%20fantasy%20landscape%2C%20warm%20golden%20light%2C%20adventure%20poster%20art&width=600&height=900&seq=anime-cover-05&orientation=portrait",
    rating: 8.7,
    type: "冒险",
    region: "日本",
    year: 2022,
    status: "已完结",
    episodes: 24,
    totalEpisodes: 24,
    popularity: 8130,
    updatedAt: "2024-08-18",
    summary: "少年踏上龙脊山脉，寻找传说中守护世界的龙魂。",
    synopsis: "传说世界的骨架是一条沉睡的巨龙。少年伊恩继承了父亲未完成的遗愿，带着断剑穿越九重山脉。途中的每一次抉择，都让他离真相更近，也离成为真正的守护者更近。",
    tags: ["奇幻", "成长", "史诗"],
    episodesList: [
      { no: 1, title: "断剑与遗愿", duration: "24:00" },
      { no: 2, title: "山脚的村庄", duration: "24:00" },
      { no: 3, title: "第一关", duration: "23:50" },
      { no: 4, title: "雾之谷", duration: "24:00" },
      { no: 5, title: "同行者", duration: "24:10" },
      { no: 6, title: "熔岩之路", duration: "24:00" },
      { no: 7, title: "龙鳞的传说", duration: "23:55" },
      { no: 8, title: "试炼", duration: "24:00" },
      { no: 9, title: "风之阶梯", duration: "24:20" },
      { no: 10, title: "失落的碑文", duration: "24:00" },
      { no: 11, title: "旧敌重逢", duration: "23:58" },
      { no: 12, title: "雪线之上", duration: "24:00" },
      { no: 13, title: "最后的隘口", duration: "24:05" },
      { no: 14, title: "龙魂之影", duration: "24:00" },
      { no: 15, title: "抉择", duration: "23:50" },
      { no: 16, title: "重铸断剑", duration: "24:00" },
      { no: 17, title: "守护的意义", duration: "24:10" },
      { no: 18, title: "回归", duration: "24:00" },
      { no: 19, title: "最后的山脉", duration: "24:00" },
      { no: 20, title: "龙脊", duration: "24:30" },
      { no: 21, title: "沉睡者", duration: "24:00" },
      { no: 22, title: "唤醒", duration: "24:05" },
      { no: 23, title: "世界的骨架", duration: "24:00" },
      { no: 24, title: "新的传说", duration: "26:00" },
    ],
  },
  {
    id: "6",
    title: "时空回廊",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20detective%20standing%20in%20an%20endless%20mirrored%20corridor%20with%20clock%20motifs%2C%20moody%20amber%20light%2C%20mysterious%20atmosphere%2C%20detailed%20poster%20art&width=600&height=900&seq=anime-cover-06&orientation=portrait",
    rating: 9.1,
    type: "悬疑",
    region: "美国",
    year: 2024,
    status: "连载中",
    episodes: 6,
    totalEpisodes: 10,
    popularity: 8760,
    updatedAt: "2024-10-07",
    summary: "一桩命案，牵出可以穿越回廊的时间谜题。",
    synopsis: "侦探诺兰接到一桩无法解释的凶案：死者竟在未来七天后死亡。随着调查深入，他发现城市中存在一条可以穿越时间的「回廊」。每一次回溯，都在改写下一次悲剧的起点。",
    tags: ["推理", "时间", "烧脑"],
    episodesList: [
      { no: 1, title: "七天后的死者", duration: "26:00" },
      { no: 2, title: "回廊入口", duration: "25:40" },
      { no: 3, title: "第一个悖论", duration: "26:10" },
      { no: 4, title: "重复的雨夜", duration: "25:50" },
      { no: 5, title: "镜中真相", duration: "26:00" },
      { no: 6, title: "闭环", duration: "27:00" },
    ],
  },
  {
    id: "7",
    title: "猫娘日常",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20cute%20cat%20girls%20relaxing%20in%20a%20cozy%20sunlit%20cafe%2C%20soft%20cream%20and%20orange%20palette%2C%20healing%20slice%20of%20life%20scene%2C%20detailed%20poster%20art&width=600&height=900&seq=anime-cover-07&orientation=portrait",
    rating: 8.3,
    type: "日常",
    region: "日本",
    year: 2021,
    status: "已完结",
    episodes: 12,
    totalEpisodes: 12,
    popularity: 5640,
    updatedAt: "2024-06-30",
    summary: "一间小咖啡馆里，猫娘们的慵懒治愈日常。",
    synopsis: "街角的「喵喵咖啡屋」住着三只会变成少女的猫咪。她们为每一位客人泡一杯温热的咖啡，也分享彼此的烦恼与小确幸。没有惊天动地，只有慢慢流淌的温柔时光。",
    tags: ["治愈", "搞笑", "萌系"],
    episodesList: [
      { no: 1, title: "今天是开业日", duration: "22:00" },
      { no: 2, title: "第一位客人", duration: "22:00" },
      { no: 3, title: "下午茶大作战", duration: "21:50" },
      { no: 4, title: "雨天的心情", duration: "22:00" },
      { no: 5, title: "新来的成员", duration: "22:10" },
      { no: 6, title: "夏天的刨冰", duration: "22:00" },
      { no: 7, title: "秘密食谱", duration: "21:55" },
      { no: 8, title: "深夜营业", duration: "22:00" },
      { no: 9, title: "流浪的小猫", duration: "22:20" },
      { no: 10, title: "圣诞愿望", duration: "22:00" },
      { no: 11, title: "春天来了", duration: "21:58" },
      { no: 12, title: "永远的味道", duration: "23:30" },
    ],
  },
  {
    id: "8",
    title: "剑与幻境",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20knight%20raising%20a%20glowing%20sword%20in%20a%20magical%20forest%20with%20floating%20runes%2C%20emerald%20and%20gold%20tones%2C%20fantasy%20adventure%20poster%20art&width=600&height=900&seq=anime-cover-08&orientation=portrait",
    rating: 8.6,
    type: "奇幻",
    region: "中国",
    year: 2024,
    status: "连载中",
    episodes: 10,
    totalEpisodes: 16,
    popularity: 8030,
    updatedAt: "2024-10-04",
    summary: "平凡铁匠学徒，意外获得能召唤幻境的神剑。",
    synopsis: "铁匠学徒林烨在修补一柄古剑时，被卷入名为「幻境」的平行世界。这里的一切由剑与符文构筑，而他的每一次胜利都会让现实世界发生改变。为了守护两界，他必须学会驾驭这把桀骜的神剑。",
    tags: ["魔法", "双世界", "成长"],
    episodesList: [
      { no: 1, title: "古剑", duration: "24:00" },
      { no: 2, title: "幻境初现", duration: "24:00" },
      { no: 3, title: "符文的意义", duration: "23:55" },
      { no: 4, title: "剑灵", duration: "24:10" },
      { no: 5, title: "两界的裂缝", duration: "24:00" },
      { no: 6, title: "试炼之森", duration: "24:05" },
      { no: 7, title: "旧日誓约", duration: "23:50" },
      { no: 8, title: "熔炉之心", duration: "24:00" },
      { no: 9, title: "王都之影", duration: "24:15" },
      { no: 10, title: "剑之所向", duration: "25:00" },
    ],
  },
  {
    id: "9",
    title: "机械纪元",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20pilot%20inside%20a%20towering%20mecha%20cockpit%2C%20industrial%20sci-fi%20hangar%20background%2C%20orange%20and%20steel%20gray%20tones%2C%20epic%20mecha%20poster%20art&width=600&height=900&seq=anime-cover-09&orientation=portrait",
    rating: 8.9,
    type: "机甲",
    region: "日本",
    year: 2023,
    status: "连载中",
    episodes: 15,
    totalEpisodes: 24,
    popularity: 8890,
    updatedAt: "2024-10-03",
    summary: "人类最后的希望，是一群被废弃的旧式机甲。",
    synopsis: "在机械文明崩塌后的荒原上，少年驾驶员与一台被宣判报废的旧式机甲相遇。当巨型敌机再次降临，他们用不完美的身躯，撑起人类最后的防线。所谓传奇，不过是不肯倒下。",
    tags: ["机甲", "末世", "热血"],
    episodesList: [
      { no: 1, title: "废铁", duration: "24:00" },
      { no: 2, title: "启动", duration: "24:00" },
      { no: 3, title: "第一次出击", duration: "24:10" },
      { no: 4, title: "荒原补给站", duration: "24:00" },
      { no: 5, title: "旧时代的驾驶员", duration: "23:55" },
      { no: 6, title: "钢之心脏", duration: "24:00" },
      { no: 7, title: "沙暴来袭", duration: "24:05" },
      { no: 8, title: "同伴的机体", duration: "24:00" },
      { no: 9, title: "地下工厂", duration: "24:20" },
      { no: 10, title: "被遗忘的编号", duration: "24:00" },
      { no: 11, title: "决堤", duration: "23:58" },
      { no: 12, title: "重逢", duration: "24:00" },
      { no: 13, title: "共同作战", duration: "24:10" },
      { no: 14, title: "耗尽", duration: "24:00" },
      { no: 15, title: "机械纪元", duration: "25:30" },
    ],
  },
  {
    id: "10",
    title: "幽夜物语",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20lantern%20lit%20old%20japanese%20street%20at%20night%20with%20faint%20spirits%2C%20deep%20indigo%20and%20amber%20tones%2C%20eerie%20yet%20beautiful%20atmosphere%2C%20poster%20art&width=600&height=900&seq=anime-cover-10&orientation=portrait",
    rating: 8.4,
    type: "恐怖",
    region: "日本",
    year: 2022,
    status: "已完结",
    episodes: 12,
    totalEpisodes: 12,
    popularity: 6210,
    updatedAt: "2024-07-21",
    summary: "深夜的旧街，每一盏灯下都藏着一个故事。",
    synopsis: "传说在午夜之后，古老的商店街会浮现出不存在的灯笼。能看见它们的人，将背负一段未了的心愿。少女千寻继承了祖母的灯笼铺，也继承了一份与幽夜打交道的工作。",
    tags: ["妖怪", "单元剧", "氛围"],
    episodesList: [
      { no: 1, title: "灯笼铺", duration: "22:40" },
      { no: 2, title: "雨巷", duration: "22:00" },
      { no: 3, title: "镜中客人", duration: "22:10" },
      { no: 4, title: "无面艺人", duration: "22:00" },
      { no: 5, title: "旧戏台", duration: "22:30" },
      { no: 6, title: "纸灯与愿", duration: "22:00" },
      { no: 7, title: "桥下水声", duration: "22:15" },
      { no: 8, title: "借来的影", duration: "22:00" },
      { no: 9, title: "午夜列车", duration: "22:20" },
      { no: 10, title: "祖母的笔记", duration: "22:00" },
      { no: 11, title: "最后一盏灯", duration: "22:40" },
      { no: 12, title: "天明", duration: "23:20" },
    ],
  },
  {
    id: "11",
    title: "恋上咖啡屋",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20barista%20and%20a%20girl%20sharing%20coffee%20in%20a%20warm%20sunlit%20cafe%2C%20caramel%20and%20cream%20tones%2C%20cozy%20romance%20scene%2C%20poster%20art&width=600&height=900&seq=anime-cover-11&orientation=portrait",
    rating: 8.2,
    type: "恋爱",
    region: "日本",
    year: 2024,
    status: "连载中",
    episodes: 7,
    totalEpisodes: 12,
    popularity: 6310,
    updatedAt: "2024-10-06",
    summary: "一杯拿铁，一段从咖啡香开始的慢热恋情。",
    synopsis: "深夜咖啡屋的常客与沉默的咖啡师，因一杯特调渐渐靠近。城市很大，但总有一盏灯为晚归的人亮着。这是一个关于慢下来、认真喜欢一个人的故事。",
    tags: ["都市", "慢热", "甜宠"],
    episodesList: [
      { no: 1, title: "深夜常客", duration: "23:00" },
      { no: 2, title: "特调的名字", duration: "23:00" },
      { no: 3, title: "雨天的座位", duration: "22:50" },
      { no: 4, title: "手写菜单", duration: "23:10" },
      { no: 5, title: "打烊之后", duration: "23:00" },
      { no: 6, title: "告白前夜", duration: "22:55" },
      { no: 7, title: "第二杯免费", duration: "23:30" },
    ],
  },
  {
    id: "12",
    title: "炎之剑士",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20swordsman%20surrounded%20by%20blazing%20flames%20holding%20a%20fire%20katana%2C%20intense%20red%20orange%20palette%2C%20dynamic%20action%20poster%20art&width=600&height=900&seq=anime-cover-12&orientation=portrait",
    rating: 8.8,
    type: "热血",
    region: "日本",
    year: 2021,
    status: "已完结",
    episodes: 26,
    totalEpisodes: 26,
    popularity: 8450,
    updatedAt: "2024-05-12",
    summary: "背负灭族之仇的剑士，以炎为刃斩尽妖邪。",
    synopsis: "一夜之间，炎之一族尽数陨落。唯一存活的少年带着祖传的炎之刀，踏上复仇与自我救赎之路。火焰既是诅咒也是力量，而真正的敌人，或许藏在自己的血脉之中。",
    tags: ["复仇", "剑术", "王道"],
    episodesList: [
      { no: 1, title: "灭族之夜", duration: "24:00" },
      { no: 2, title: "炎之刀", duration: "24:00" },
      { no: 3, title: "第一滴血", duration: "23:55" },
      { no: 4, title: "同行修行", duration: "24:00" },
      { no: 5, title: "铁匠村", duration: "24:05" },
      { no: 6, title: "四天王的试炼", duration: "24:00" },
      { no: 7, title: "炎之形态", duration: "24:10" },
      { no: 8, title: "旧仇", duration: "24:00" },
      { no: 9, title: "雪与火", duration: "23:50" },
      { no: 10, title: "背叛", duration: "24:00" },
      { no: 11, title: "血脉的秘密", duration: "24:15" },
      { no: 12, title: "觉醒", duration: "24:00" },
      { no: 13, title: "城下之战", duration: "24:05" },
      { no: 14, title: "燃烧殆尽", duration: "24:00" },
      { no: 15, title: "同伴的代价", duration: "23:58" },
      { no: 16, title: "未完的剑", duration: "24:00" },
      { no: 17, title: "复仇的意义", duration: "24:10" },
      { no: 18, title: "真凶", duration: "24:00" },
      { no: 19, title: "血脉相连", duration: "24:00" },
      { no: 20, title: "炎之抉择", duration: "24:20" },
      { no: 21, title: "最后的刀", duration: "24:00" },
      { no: 22, title: "灰烬", duration: "23:55" },
      { no: 23, title: "黎明", duration: "24:00" },
      { no: 24, title: "新的火种", duration: "24:00" },
      { no: 25, title: "归乡", duration: "24:30" },
      { no: 26, title: "炎之剑士", duration: "26:00" },
    ],
  },
  {
    id: "13",
    title: "太空漂流记",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20an%20astronaut%20floating%20before%20a%20giant%20ringed%20planet%2C%20deep%20space%20backdrop%20with%20warm%20nebula%20glow%2C%20wonder%20and%20scale%2C%20poster%20art&width=600&height=900&seq=anime-cover-13&orientation=portrait",
    rating: 8.6,
    type: "科幻",
    region: "美国",
    year: 2023,
    status: "连载中",
    episodes: 9,
    totalEpisodes: 13,
    popularity: 7250,
    updatedAt: "2024-09-29",
    summary: "一场事故后，太空站唯一的幸存者开始漂流。",
    synopsis: "补给船失事后，宇航员艾米丽成为轨道站唯一活着的人。她一边修复残破的船体，一边接收来自地球断断续续的讯号。孤独是最大的敌人，而希望，就藏在每一次微弱的通讯里。",
    tags: ["太空", "生存", "硬科幻"],
    episodesList: [
      { no: 1, title: "事故", duration: "25:00" },
      { no: 2, title: "幸存", duration: "24:30" },
      { no: 3, title: "修复", duration: "24:00" },
      { no: 4, title: "微弱讯号", duration: "24:10" },
      { no: 5, title: "孤独的生日", duration: "24:00" },
      { no: 6, title: "太阳能板", duration: "24:05" },
      { no: 7, title: "旧视频", duration: "23:55" },
      { no: 8, title: "希望的火光", duration: "24:00" },
      { no: 9, title: "归途在望", duration: "25:00" },
    ],
  },
  {
    id: "14",
    title: "校园怪谈社",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20students%20exploring%20a%20dim%20old%20school%20corridor%20at%20dusk%20with%20a%20flashlight%2C%20mysterious%20green%20and%20amber%20tones%2C%20poster%20art&width=600&height=900&seq=anime-cover-14&orientation=portrait",
    rating: 8.0,
    type: "悬疑",
    region: "中国",
    year: 2024,
    status: "连载中",
    episodes: 5,
    totalEpisodes: 12,
    popularity: 5860,
    updatedAt: "2024-10-02",
    summary: "放学后的旧校舍，藏着无人敢提的七个怪谈。",
    synopsis: "为了拯救即将被拆除的旧校舍，文学社四人组成立了「怪谈社」，决定亲自验证流传的七大校园怪谈。随着调查深入，他们发现怪谈背后，其实连着一段被遗忘的真实往事。",
    tags: ["校园", "解谜", "轻恐怖"],
    episodesList: [
      { no: 1, title: "怪谈社成立", duration: "23:00" },
      { no: 2, title: "消失的第十三阶", duration: "23:10" },
      { no: 3, title: "音乐室的琴声", duration: "23:00" },
      { no: 4, title: "旧照片", duration: "22:50" },
      { no: 5, title: "被遗忘的往事", duration: "23:30" },
    ],
  },
  {
    id: "15",
    title: "花火之夏",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20teenagers%20in%20yukata%20watching%20fireworks%20by%20a%20river%20at%20night%2C%20warm%20golden%20and%20violet%20sky%20tones%2C%20nostalgic%20summer%20festival%20poster%20art&width=600&height=900&seq=anime-cover-15&orientation=portrait",
    rating: 8.5,
    type: "治愈",
    region: "日本",
    year: 2022,
    status: "已完结",
    episodes: 11,
    totalEpisodes: 11,
    popularity: 6640,
    updatedAt: "2024-06-15",
    summary: "那年夏天的花火下，我们约好要一直在一起。",
    synopsis: "小城的夏天，总在花火大会那天最热闹。五个从小一起长大的少年少女，在这个夏天迎来了各自的离别与告白。青春像花火，短暂却耀眼，而回忆会一直亮着。",
    tags: ["青春", "离别", "怀旧"],
    episodesList: [
      { no: 1, title: "夏天的开始", duration: "22:30" },
      { no: 2, title: "河堤的约定", duration: "22:00" },
      { no: 3, title: "补习的午后", duration: "22:10" },
      { no: 4, title: "烟火摊", duration: "22:00" },
      { no: 5, title: "未说出口的话", duration: "22:20" },
      { no: 6, title: "台风夜", duration: "22:00" },
      { no: 7, title: "车站", duration: "22:15" },
      { no: 8, title: "花火大会", duration: "23:00" },
      { no: 9, title: "告白", duration: "22:30" },
      { no: 10, title: "各自的夏天", duration: "22:00" },
      { no: 11, title: "明年再会", duration: "24:00" },
    ],
  },
  {
    id: "16",
    title: "铁血军魂",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20soldiers%20standing%20firm%20on%20a%20battlefield%20at%20dawn%20with%20a%20raising%20flag%2C%20muted%20amber%20and%20steel%20tones%2C%20solemn%20heroic%20poster%20art&width=600&height=900&seq=anime-cover-16&orientation=portrait",
    rating: 8.7,
    type: "战斗",
    region: "中国",
    year: 2023,
    status: "已完结",
    episodes: 18,
    totalEpisodes: 18,
    popularity: 7790,
    updatedAt: "2024-08-05",
    summary: "一群年轻士兵，在战火中淬炼成钢的成长史诗。",
    synopsis: "战争爆发，一群来自天南地北的年轻人被编入同一支连队。从最初的手忙脚乱，到战场上的生死相托，他们用鲜血与信念，写下一段关于责任与兄弟情的铁血故事。",
    tags: ["战争", "群像", "热血"],
    episodesList: [
      { no: 1, title: "入伍", duration: "24:00" },
      { no: 2, title: "第一课", duration: "24:00" },
      { no: 3, title: "射击训练", duration: "23:55" },
      { no: 4, title: "夜行军", duration: "24:00" },
      { no: 5, title: "第一场演习", duration: "24:10" },
      { no: 6, title: "战友", duration: "24:00" },
      { no: 7, title: "真实的战场", duration: "24:05" },
      { no: 8, title: "坚守阵地", duration: "24:00" },
      { no: 9, title: "断后的命令", duration: "23:58" },
      { no: 10, title: "黎明突击", duration: "24:00" },
      { no: 11, title: "医务兵", duration: "24:00" },
      { no: 12, title: "家书", duration: "23:50" },
      { no: 13, title: "雪地行军", duration: "24:00" },
      { no: 14, title: "最后的防线", duration: "24:20" },
      { no: 15, title: "兄弟", duration: "24:00" },
      { no: 16, title: "反攻", duration: "24:00" },
      { no: 17, title: "凯旋之前", duration: "24:05" },
      { no: 18, title: "军魂不朽", duration: "26:00" },
    ],
  },
  {
    id: "17",
    title: "精灵契约",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20young%20summoner%20with%20a%20glowing%20spirit%20companion%20in%20an%20enchanted%20meadow%2C%20emerald%20and%20orange%20tones%2C%20fantasy%20adventure%20poster%20art&width=600&height=900&seq=anime-cover-17&orientation=portrait",
    rating: 8.4,
    type: "奇幻",
    region: "日本",
    year: 2024,
    status: "连载中",
    episodes: 11,
    totalEpisodes: 15,
    popularity: 7680,
    updatedAt: "2024-10-01",
    summary: "与世界各地的精灵缔结契约，成为真正的召唤师。",
    synopsis: "在这个世界，少数人能与精灵签订契约。少女艾拉梦想成为最强的召唤师，却只召唤出一只胆小的小精灵。直到某天，她发现这个不起眼的伙伴，藏着传说中的古老力量。",
    tags: ["召唤", "伙伴", "冒险"],
    episodesList: [
      { no: 1, title: "第一次召唤", duration: "24:00" },
      { no: 2, title: "胆小的伙伴", duration: "24:00" },
      { no: 3, title: "契约学院", duration: "23:55" },
      { no: 4, title: "入学考试", duration: "24:10" },
      { no: 5, title: "第一场对决", duration: "24:00" },
      { no: 6, title: "精灵的故乡", duration: "24:05" },
      { no: 7, title: "隐藏的力量", duration: "24:00" },
      { no: 8, title: "对决强敌", duration: "23:58" },
      { no: 9, title: "信任", duration: "24:00" },
      { no: 10, title: "古代契约", duration: "24:15" },
      { no: 11, title: "共同成长", duration: "25:00" },
    ],
  },
  {
    id: "18",
    title: "深海之歌",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20girl%20singing%20among%20glowing%20jellyfish%20in%20a%20deep%20blue%20underwater%20realm%2C%20teal%20and%20gold%20bioluminescent%20glow%2C%20ethereal%20healing%20poster%20art&width=600&height=900&seq=anime-cover-18&orientation=portrait",
    rating: 8.6,
    type: "治愈",
    region: "日本",
    year: 2023,
    status: "已完结",
    episodes: 10,
    totalEpisodes: 10,
    popularity: 6920,
    updatedAt: "2024-07-08",
    summary: "海底深处，歌声能治愈所有受伤的心。",
    synopsis: "在人类未曾抵达的深海，存在着会唱歌的种族。少女琉音为了寻找失踪的母亲，第一次浮上海面。她的歌声不仅能安抚海兽，也能治愈陆地上人们破碎的心。",
    tags: ["海底", "音乐", "温情"],
    episodesList: [
      { no: 1, title: "深海之音", duration: "23:00" },
      { no: 2, title: "浮出水面", duration: "22:50" },
      { no: 3, title: "第一次唱歌", duration: "23:00" },
      { no: 4, title: "陆地的朋友", duration: "23:10" },
      { no: 5, title: "母亲的手链", duration: "23:00" },
      { no: 6, title: "风暴之夜", duration: "22:55" },
      { no: 7, title: "海兽", duration: "23:00" },
      { no: 8, title: "古老的旋律", duration: "23:20" },
      { no: 9, title: "重逢的预兆", duration: "23:00" },
      { no: 10, title: "深海之歌", duration: "25:00" },
    ],
  },
  {
    id: "19",
    title: "拳皇传说",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20fierce%20young%20fighter%20throwing%20a%20fiery%20punch%20in%20a%20crowded%20arena%2C%20dynamic%20orange%20and%20dark%20contrast%2C%20high%20energy%20action%20poster%20art&width=600&height=900&seq=anime-cover-19&orientation=portrait",
    rating: 8.3,
    type: "热血",
    region: "日本",
    year: 2022,
    status: "已完结",
    episodes: 22,
    totalEpisodes: 22,
    popularity: 7180,
    updatedAt: "2024-06-02",
    summary: "从街头小子到擂台王者，一拳一拳打出的传说。",
    synopsis: "街头少年阿烈梦想成为最强格斗家。为了站上世界大赛的舞台，他拜师、训练、挑战一个又一个强大的对手。汗水、伤痛与热血，铺就通往王者的擂台之路。",
    tags: ["格斗", "成长", "竞技"],
    episodesList: [
      { no: 1, title: "街头霸王", duration: "23:40" },
      { no: 2, title: "拜师", duration: "23:30" },
      { no: 3, title: "基础训练", duration: "23:40" },
      { no: 4, title: "第一场擂台", duration: "23:50" },
      { no: 5, title: "对手的招式", duration: "23:30" },
      { no: 6, title: "失败", duration: "23:40" },
      { no: 7, title: "重新站起", duration: "23:30" },
      { no: 8, title: "特训", duration: "23:45" },
      { no: 9, title: "预选赛", duration: "23:40" },
      { no: 10, title: "晋级", duration: "23:30" },
      { no: 11, title: "八强", duration: "23:50" },
      { no: 12, title: "宿敌", duration: "23:40" },
      { no: 13, title: "破解招式", duration: "23:30" },
      { no: 14, title: "四强", duration: "23:55" },
      { no: 15, title: "体力极限", duration: "23:40" },
      { no: 16, title: "信念之拳", duration: "23:30" },
      { no: 17, title: "决赛对手", duration: "23:45" },
      { no: 18, title: "巅峰之战", duration: "24:00" },
      { no: 19, title: "最后一回合", duration: "23:40" },
      { no: 20, title: "拳王诞生", duration: "24:10" },
      { no: 21, title: "新的挑战", duration: "23:30" },
      { no: 22, title: "传说继续", duration: "25:00" },
    ],
  },
  {
    id: "20",
    title: "未来美食家",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20illustration%20of%20a%20chef%20cooking%20in%20a%20sleek%20futuristic%20kitchen%20with%20holographic%20recipes%2C%20warm%20orange%20and%20white%20tones%2C%20fun%20culinary%20sci-fi%20poster%20art&width=600&height=900&seq=anime-cover-20&orientation=portrait",
    rating: 8.1,
    type: "科幻",
    region: "中国",
    year: 2024,
    status: "连载中",
    episodes: 6,
    totalEpisodes: 12,
    popularity: 6020,
    updatedAt: "2024-09-27",
    summary: "在未来世界，用料理征服美食评审的味蕾。",
    synopsis: "2145 年，食物由系统统一配送，真正的料理成了稀有技艺。少年厨师承担起复兴「手作美食」的使命，用一道道带着温度的菜肴，唤醒人们对美味与生活的热爱。",
    tags: ["美食", "未来", "轻松"],
    episodesList: [
      { no: 1, title: "被遗忘的味道", duration: "22:40" },
      { no: 2, title: "第一道手作料理", duration: "22:30" },
      { no: 3, title: "美食评审", duration: "22:40" },
      { no: 4, title: "街头小摊", duration: "22:30" },
      { no: 5, title: "祖传食谱", duration: "22:50" },
      { no: 6, title: "温度的意义", duration: "23:20" },
    ],
  },
];